<template>
    <div class="consumer-name-page gom-layout">
        <template>
            <div class="title-page">
                <img :src="getImage('logo') || header">
            </div>

            <div class="header">
                <CircleButton big="true" :icon="arrow_back_white" @circleBtnClick="navigateToCheckout"></CircleButton>
                <span class="step-label">{{ getString('identificacao') }}</span>
                <!-- <DefaultButton v-if="!loggedClient" :text="getString('login_consumidor')"
                    @defaultBtnClick="clientLogin()"></DefaultButton>
                <DefaultButton v-else :text="buildLoggedPhrase()" @defaultBtnClick="showDialog()" singleLine="true">
                </DefaultButton> -->
            </div>

            <div class="gom-content">
                <div class="gom-text-area">
                    <h2 class="gom-title"><span>{{ getString('como_deseja_ser_chamado') }}</span></h2>
                </div>

                <div class="gom-input-container">
                    <div class="gom-input-underline-container" @click.stop="switchActiveInput('nameDivGom')"
                        :class="{ 'active': isTheActiveInput('nameDivGom') }">
                        <div ref="nameDivGom" class="value div-input-android"
                            :data-placeholder="getString('digite_seu_nome')" :class="{ 'is-empty': !consumerName }">
                            {{ consumerName }}
                        </div>
                    </div>
                    <div class="gom-action-buttons">
                        <DefaultButton :outlined="true" :text="getString('nao_informar')" layoutGom="true"
                            @defaultBtnClick="handleBtnAction(skipName)" />
                        <DefaultButton :text="getString('confirmar')" :disabled="consumerName.length < 3"
                            layoutGom="true" @defaultBtnClick="handleBtnAction(confirmName)" />
                    </div>
                </div>
                <div class="keyboard-area" v-if="inputElement">
                    <AndroidKeyboard ref="keyboard" :inputElement="inputElement" :layout="layout" :onInput="handleInput"
                        :maxCaracteres="30" />
                </div>
            </div>
        </template>

        <div class="gom-navigation-footer">
            <DefaultButton :text="getString('voltar_cardapio')" @defaultBtnClick="handleBtnAction(navigateToHome)"
                layoutGom="true" outlined="true" />
            <DefaultButton :text="getString('cancelar_pedido')" @defaultBtnClick="handleBtnAction(clearCartAndReset)"
                layoutGom="true" outlined="true" />
        </div>

    </div>
</template>

<script>
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '@/assets/controllers/CartController'
import CircleButton from '@/components/CircleButton'
import Util from '@/assets/libs/util'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
export default {
    name: 'ConsumerName',
    components: {
        DefaultButton,
        AndroidKeyboard,
        CircleButton
    },
    data () {
        return {
            consumerName: '',
            loggedClient: false,
            showModal: false,
            personalCreditMethod: null,
            changeConsumerFor: '',
            arrow_back_white: require('../../static/icons/arrow_back_white.svg'),
            header: require('../../static/client/header.png'),
            inputElement: null,
            layout: keyboardLayout.NAME,
            usePager: Util.getLocalConfigs('usePager'),
            cart: CartController.getCart()
        }
    },
    computed: {
        useGomLayout () {
            return Util.getLocalConfigs('utiliza_layout_gom') || false
        },
        isKeyboardOpen () {
            return this.inputElement !== null
        }
    },
    mounted () {
        if (this.cart.length === 0) {
            // caso o carrinho esteja vazio volte para a home para evitar erro de pagamento
            Util.showInfoModal(this.getString('erro_comanda_vazia'))
            this.$router.push('Home')
        }
        if (IdentifiedConsumerController.userIsLogged()) {
            this.consumerName = IdentifiedConsumerController.getConsumerData().consumerName.toUpperCase() || ''
        }
        const savedName = CartController.getConsumerName()
        if (savedName) {
            this.consumerName = savedName.toUpperCase()
        }
        this.$nextTick(() => {
            this.switchActiveInput('nameDivGom')
        })
    },
    methods: {
        getString (key) {
            return LocaleController.getString(key)
        },
        getImage: function (value) {
            return Util.getConfigImage(value)
        },
        navigateToHome () {
            CartController.navigateToHome(this.$router)
        },
        handleBtnAction (callback) {
            this.closeKeyboard()
            if (callback) callback()
        },
        reapplyDiffPrices: async function () {
            if (!Util.isTapMode()) {
                await CartController.applyDifferentiatedPrices()
            }
        },
        clearCartAndReset () {
            Util.showConfirmationDialog(this.$modal, () => {
                CartController.clearCartAndNavigateHome(this.$router)
            }, this.getString('deseja_limpar_carrinho'))
        },
        /* clientLogin: function () {
            this.showLoginModal()
        },
        showLoginModal: function (method) {
            this.personalCreditMethod = method
            this.showModal = true
        }, */
        isTheActiveInput (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput (divReference) {
            this.inputElement = this.$refs[divReference]
        },
        handleInput (text) {
            const value = (text || '').toUpperCase()
            this.consumerName = value
            return value
        },
        closeKeyboard () {
            this.inputElement = null
        },
        saveAndNavigate () {
            if (CartController.setConsumerName) {
                CartController.setConsumerName(this.consumerName)
            }
            CartController.navigateToPayment(this.$router)
        },
        navigateToCheckout: function () {
            if (this.usePager) {
                CartController.navigateToPager(this.$router)
            } else {
                CartController.navigateToCheckout(this.$router)
            }
        },
        confirmName () {
            if (this.consumerName.length >= 3) {
                this.saveAndNavigate()
            }
        },
        skipName () {
            this.consumerName = ''
            this.saveAndNavigate()
        }
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.consumer-name-page {
    width: 100vw;
    height: calc(100vh - 60px);
    display: grid;
    grid-template-rows: 180px 150px 1fr 120px 0;
    overflow: hidden;
    background-color: #ffffff;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 2rem;
        z-index: 10;
        flex-shrink: 0;

        .step-label {
            font-size: 3rem;
            color: @primary-dark;
            font-weight: bold;

            &:last-child {
                margin: auto;
            }
        }
    }

    .title-page {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        background-color: @header-color;
        width: 100vw;

        img {
            height: 160px;
            padding: 10px 0;
        }
    }

    .gom-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        width: auto;
        overflow-y: auto;
        padding: 0 85px;

        .gom-text-area {
            text-align: center;
            margin: 2vh 0;

            .gom-title {
                font-size: 2.2rem;
                color: #333;
                text-transform: uppercase;

                span {
                    color: @primary-dark;
                }
            }
        }

        .gom-input-container {
            width: 100%;
            .gom-input-underline-container {
                padding: 20px 20px;
                background: rgb(225, 225, 225);
                border-bottom: 3px solid @primary-color;
                box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
                border-radius: 10px;
                // margin-bottom: 30px;
                margin: 0 10px;
                align-self: stretch;

                .value {
                    font-size: 2.2rem;
                    min-height: 40px;
                    color: #222;
                    text-transform: uppercase;
                }

                &.active {
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    transform: scale(1.01);
                    transition: all 0.2s ease;
                    content: '';
                }

                .div-input-android.is-empty::before {
                    content: attr(data-placeholder);
                    color: #9e9e9e;
                    pointer-events: none;
                }
            }

            .gom-action-buttons {
                display: flex;
                align-self: stretch;
                // width: 100%;
                justify-content: space-between;
                gap: 20px;
                margin: 50px 0;
                padding: 0 10px;

                button {
                    flex: 1;
                }
            }
        }
    }

    .gom-navigation-footer {
        display: flex;
        flex-direction: row;
        // margin: 10px 0;
        bottom: 0;
        left: 0;
        width: 100%;
        justify-content: center;
        align-items: center;
        height: 100px;
        animation: upper-in 0.4s;
        will-change: transform, opacity;

        button {
            margin: 0 30px;
            width: 50%;
            text-transform: uppercase;
        }
    }

    // CONTAINER DO TECLADO
    .keyboard-area {
        width: 100%;
        // box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);
        z-index: 5;
        flex-shrink: 0;

        .android-keyboard {
            background: #e0e0e0;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    .consumer-name-page {
        height: calc(100vh - 60px);
        grid-template-rows: 130px 100px 1fr 130px 0;

        .title-page {
            height: 130px;

            img {
                height: 90px;
                padding: 10px 0;
            }
        }

        .header {
            .step-label {
                font-size: 2.8rem;

                &:last-child {
                    margin: auto;
                }
            }
        }

        .gom-content {
            padding: 0 40px;

            .gom-text-area {
                margin: 1.7vh 0;

                .gom-title {
                    font-size: 1.8rem;

                    span {
                        color: @primary-dark;
                    }
                }
            }

            .gom-input-container .gom-input-underline-container {
                padding: 15px 15px;
                border-radius: 10px;
                margin: 0 10px;
                align-self: stretch;

                .value {
                    font-size: 1.9rem;
                }

                &.active {
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    transform: scale(1.01);
                    transition: all 0.2s ease;
                }
            }

            .gom-input-container .gom-action-buttons {
                display: flex;
                align-self: stretch;
                justify-content: space-between;
                gap: 15px;
                margin: 50px 0;
                padding: 0 10px;

                button {
                    flex: 1;
                }
            }
        }

        .gom-navigation-footer {
            height: 100px;

            button {
                margin: 0 30px;
                width: 50%;
                text-transform: uppercase;
            }
        }
    }
}

@media (max-width: 698px) {
    .consumer-name-page {
        height: calc(100vh - 30px);
        grid-template-rows: 65px auto 70px 0;

        .title-page {
            display: none;
        }

        .header {
            padding: 0 2rem;

            .step-label {
                font-size: 25px;
                font-weight: normal;

                &:last-child {
                    margin: auto;
                }
            }

            .button-default {
                height: 45px;
            }
        }

        .gom-content {
            padding: 1rem 2rem;

            .gom-text-area {
                margin: 1.7vh 0;

                .gom-title {
                    font-size: 22px;

                    span {
                        color: @primary-dark;
                    }
                }
            }

            .gom-input-container .gom-input-underline-container {
                padding: 8px 8px;
                border-radius: 5px;
                margin: 0 10px;
                align-self: stretch;

                .value {
                    font-size: 20px;
                    min-height: 10px;
                }

                &.active {
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    transform: scale(1.01);
                    transition: all 0.2s ease;
                }
            }

            .gom-input-container .gom-action-buttons {
                display: flex;
                align-self: stretch;
                justify-content: space-between;
                gap: 15px;
                margin: 25px 0;
                padding: 0 10px;

                button {
                    flex: 1;
                }
            }
        }

        .gom-navigation-footer {
            height: 70px;

            button {
                margin: 0 5px;
                width: 50%;
                text-transform: uppercase;
            }
        }
    }
}

@media (orientation: landscape) {
    .consumer-name-page {
        height: calc(100vh - 30px);
        grid-template-rows: 80px 80px auto 100px;

        .title-page {
            height: 80px;

            img {
                height: 70px;
                padding: 5px 0;
            }
        }

        .header {
            padding: 0 100px;
            .step-label {
                font-size: 2rem;
                font-weight: normal;

                &:last-child {
                    margin: auto;
                }
            }
            .btn-big {
                width: 50px;
                height: 50px;
            }
        }

        .gom-content {
            padding: 0 80px;

            .gom-text-area {
                margin: 1.7vh 0;
                width: calc(100% - 20px);
                display: flex;
                justify-content: start;
                align-items: start;
                margin-left: 20px;
                .gom-title {
                    font-size: 1.6rem;

                    span {
                        color: @primary-dark;
                    }
                }
            }

            .gom-input-container {
                display: grid;
                grid-template-columns: 1.5fr 1fr;
                align-items: center;
                width: calc(100% - 20px);
                padding: 0 10px;
                .gom-input-underline-container {
                    padding: 15px 15px;
                    border-radius: 10px;
                    margin: 0 10px;
                    align-self: unset;

                    .value {
                        font-size: 1.6rem;
                        min-height: 10px;
                    }

                    &.active {
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                        transform: scale(1.01);
                        transition: all 0.2s ease;
                    }
                }

                .gom-action-buttons {
                    display: flex;
                    align-self: unset;
                    justify-content: space-between;
                    gap: 15px;
                    margin: 15px 0;
                    padding: 0 10px;

                    button {
                        flex: 1;
                    }
                }
        }
    }

        .gom-navigation-footer {
            height: 100px;

            button {
                margin: 0 30px;
                width: 50%;
                text-transform: uppercase;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ConsumerName.vue